import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, useContext, } from 'react';
import styleUtils from '../../styles/styleUtils';
import { PickerOption, } from '../Picker';
import { ThumbnailCarouselContext } from './ThumbnailCarouselContext';
const ThumbnailCarouselOption = ({ alt, ariaDescribedBy, ariaLabel, ariaLabelledBy, id, src, value, }) => {
    const { slideSize, } = useContext(ThumbnailCarouselContext);
    const thumbnailStyles = useMemo(() => (css `
        height: ${styleUtils.rem(slideSize)};
        width: ${styleUtils.rem(slideSize)};
      `), [
        slideSize,
    ]);
    return (_jsx(PickerOption, Object.assign({ ariaDescribedBy: ariaDescribedBy, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, id: id || value, value: value }, { children: _jsx("img", { alt: alt, css: thumbnailStyles, src: src }) })));
};
const MemoizedThumbnailCarouselOption = memo(ThumbnailCarouselOption);
export { MemoizedThumbnailCarouselOption as ThumbnailCarouselOption };
// MC-1068 Temporary hack for Storybook.
export default ThumbnailCarouselOption;
